<div class="ds-grid ds-grid--1">
	<div class="ds-example">
		<div class="ds-example__content">
			<eif-faq-manager [showFormatInfo]="true"></eif-faq-manager>
		</div>
	</div>
</div>
